<template>
    <div class="card  pl-2 pr-2 col-md-12" v-if="task.flawtype">
        <div class="bg-white card-body screen-height p-3 cscroll border-left w-100">

          <details-tab :showPlan="showPlan"/>

          <history-tab/>

        </div>
      <div class="clearfix"></div>
    </div>
  <div class="card" v-else>
    <div class="card-body">
      <h2 class="text-center">Keine Mangel ausgewählt</h2>
    </div>
  </div>
</template>
<script>
import DetailsTab from './preview-tabs/DetailsTab'
import HistoryTab from './preview-tabs/HistoryTab'
import {mapState} from 'vuex'
export default {
  components : { HistoryTab, DetailsTab },
  data(){
    return {
      showPlan: false
    }
  },
  computed: {
    ...mapState({
      task: state => state.tasks.taskDetails
    }),
  }

}
</script>
<style scoped>
.docuvtabs .tab-content {
  padding: 17px;
  font-size: 12px;
}
</style>



// WEBPACK FOOTER //
// src/components/tasks/TasksPreview.vue